<template>
	<div>
		<el-row>
			<el-col :span="6">
				<div class="grid-content bg-purple">
					<span class="span-weight">{{ $t("chatMessageCheckDetails.supplier") }}</span>
				</div>
			</el-col>
			<el-col :span="18">
				<div class="grid-content bg-purple-light">
					<p class="supplier-name">
						<span>{{ checkDetailData.supplier_name }}</span>
					</p>
				</div>
			</el-col>
		</el-row>
		<el-row>
			<el-col :span="6">
				<div class="grid-content bg-purple">
					<span class="span-weight">{{ $t("chatMessageCheckDetails.serialNumber") }}</span>
				</div>
			</el-col>
			<el-col :span="18">
				<div class="grid-content bg-purple-light">
					<p>
						<span>{{ checkDetailData.customer_id | removeFrontZero }}</span>
					</p>
				</div>
			</el-col>
		</el-row>
		<el-row>
			<el-col :span="6">
				<div class="grid-content bg-purple">
					<span class="span-weight">{{ $t("chatMessageCheckDetails.userAmount") }}</span>
				</div>
			</el-col>
			<el-col :span="18">
				<div class="grid-content bg-purple-light">
					<p>
						<span>{{ amountConversion(checkDetailData.user_amount) }}</span>
					</p>
				</div>
			</el-col>
		</el-row>
		<el-row>
			<el-col :span="6">
				<div class="grid-content bg-purple">
					<span class="span-weight">{{ $t("chatMessageCheckDetails.amount") }}</span>
				</div>
			</el-col>
			<el-col :span="18">
				<div class="grid-content bg-purple-light">
					<p>
						<span>{{ amountConversion(checkDetailData.amount) }}</span>
					</p>
				</div>
			</el-col>
		</el-row>
		<el-row>
			<el-col :span="6">
				<div class="grid-content bg-purple">
					<span class="span-weight">{{ $t("chatMessageCheckDetails.checkStatus") }}</span>
				</div>
			</el-col>
			<el-col :span="18">
				<div class="grid-content bg-purple-light">
					<p>
						<span>{{ getCheckStatusText(checkDetailData.status) }}</span>
					</p>
				</div>
			</el-col>
		</el-row>
		<el-row>
			<el-col :span="6">
				<div class="grid-content bg-purple">
					<span class="span-weight">{{ $t("chatMessageCheckDetails.uploadDate") }}</span>
				</div>
			</el-col>
			<el-col :span="18">
				<div class="grid-content bg-purple-light">
					<p>
						<span>{{ checkDetailData.created_at | messageDateFormat }}</span>
					</p>
				</div>
			</el-col>
		</el-row>
		<div class="check-image">
			<div>
				<el-image style="width: 180px; height: 100px" :src="checkDetailData.front_picture" :preview-src-list="[checkDetailData.front_picture]">
				</el-image>
				<p>{{ $t("chatMessageCheckDetails.frontPicture") }}</p>
			</div>
			<div>
				<el-image style="width: 180px; height: 100px" :src="checkDetailData.back_picture" :preview-src-list="[checkDetailData.back_picture]">
				</el-image>
				<p>{{ $t("chatMessageCheckDetails.reversePicture") }}</p>
			</div>
		</div>
	</div>
</template>
<script>
import { T } from "alife-logger/lib/util";

export default {
	name: "chat-message-check-details",

	props: {
		checkDetailData: {
			type: Object,
			required: true,
		},
	},

	methods: {
		amountConversion(amount) {
			if (typeof amount === "number") {
				return new Intl.NumberFormat("en-US", {
					style: "currency",
					currency: "USD",
				}).format(amount);
			}
			if (typeof amount === "string") {
				const numericAmount = Number(amount.slice().replace(/[^0-9.-]+/g, ""));
				if (!isNaN(numericAmount)) {
					return new Intl.NumberFormat("en-US", {
						style: "currency",
						currency: "USD",
					}).format(numericAmount);
				}
			}
			return "Invalid amount";
		},
		getCheckStatusText(status) {
			switch (status) {
				case 0:
					return "待审批";
				case 1:
					return "已过帐";
				case 2:
					return "拒付（RTN）";
				case 3:
					return "拒绝过帐";
				default:
					return "null";
			}
		},
	},
};
</script>
<style lang="less" scoped>
.span-weight {
	font-weight: 700;
	font-size: 16px;
	color: black;
	margin-bottom: 20px;
}
.grid-content {
	margin-bottom: 20px;
}

.grid-content p {
	margin-top: 0px;
	margin-bottom: 10px;
}

.check-image {
	display: flex;
	justify-content: space-around;
	> div {
		display: flex;
		flex-direction: column;
		align-items: center;
	}
}

.supplier-name {
	font-weight: 400;
	font-size: 15px;
	color: black;
}
</style>
